import { render, staticRenderFns } from "./FollowProfile.vue?vue&type=template&id=8df98ec6"
import script from "./FollowProfile.vue?vue&type=script&lang=js"
export * from "./FollowProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports